import React from 'react';
import { connect } from 'react-redux';
import { DBIntFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestCervicalDeepNeckFlexorEndurance extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Deep Neck Flexor Endurance' />
                <span className={styles.spacer} />
                <label title='Normative Values:  Men - Greater than or equal to 39 seconds; Women - Greater than or equal to 29 seconds' className={styles.label}>Deep Neck Flexor Endurance</label>
                <span className={styles.r} />
                <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    field='TSCERVDEEPNECKFLEXEND'
                    className={styles.c}
                    min={0}
                />
                <span className={styles.seconds}>seconds</span>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCERVDEEPNECKFLEXEND) {
        if (state.entities.patients[state.ui.patients.selectedPtno].gender === 'M' &&
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCERVDEEPNECKFLEXEND < 39) {
            flagged = true;
        } else if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCERVDEEPNECKFLEXEND < 29) {
            flagged = true;
        }

    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged
    };
}

const connectedSpecialTestCervicalDeepNeckFlexorEndurance = connect(mapStateToProps)(SpecialTestCervicalDeepNeckFlexorEndurance);
export { connectedSpecialTestCervicalDeepNeckFlexorEndurance as SpecialTestCervicalDeepNeckFlexorEndurance };


